import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import "./aboutpage.css"
import { FaBullseye, FaUsers } from 'react-icons/fa';
import { LuLayoutDashboard } from "react-icons/lu";

const AboutPage = () => {
  const { t } = useTranslation();
  const topRef = useRef();
  const midRef = useRef();

  const [isTopVisible, setIsTopVisible] = useState(false);
  const [isMidVisible, setIsMidVisible] = useState(false);

  useEffect(() => {
    const currentTopRef = topRef.current;
    const currentMidRef = midRef.current;

    const topObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsTopVisible(true);
          topObserver.unobserve(entry.target);
        }
      });
    });

    const midObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsMidVisible(true);
          midObserver.unobserve(entry.target);
        }
      });
    });

    if (currentTopRef) {
      topObserver.observe(currentTopRef);
    }

    if (currentMidRef) {
      midObserver.observe(currentMidRef);
    }

    return () => {
      if (currentTopRef) {
        topObserver.unobserve(currentTopRef);
      }
      if (currentMidRef) {
        midObserver.unobserve(currentMidRef);
      }
    };
  }, []);

  return (
    <div className='about-main-container'>

      <div className={`about-top-container relative ${isTopVisible ? "fade-in" : ""}`} ref={topRef}>
        <div className="about-header-content">
          <h1 className="homepage-title1 mb-0">{t('aboutPage.header.title')}</h1>
          {/* <p className="homepage-text1 mb-0">About THM Investment</p> */}
        </div>
      </div>

      <div className={`about-bottom-container ${isMidVisible ? "fade-in" : ""}`} ref={midRef}>

        <div className='md:grid grid-cols-2 gap-12 relative z-2'>
          <div className=''>
            <div className='about-img2 z-4 relative'></div>
          </div>
          <div className="py-6">
            <h1 className='homepage-title2'>{t('aboutPage.main.title')}</h1>
            <p className='homepage-text2 mb-4'>{t('aboutPage.main.desc1')}</p>
            <p className='homepage-text2 mb-4'>{t('aboutPage.main.desc2')}</p>
            <p className='homepage-text2 mb-0'>{t('aboutPage.main.desc3')}</p>
          </div>
        </div>

        <div className='md:grid grid-cols-3 gap-4 mt-12'>
          <div className='homepage-comp5-card'>
            <div className="flex gap-4 items-center mb-4">
              <div className='about-icon'>
                <FaBullseye />
              </div>
              <h2 className='homepage-title3 mb-0'>{t('aboutPage.cards.vision.title')}</h2>
            </div>
            <p className='homepage-text2 m-0'>
              <strong>{t('aboutPage.cards.vision.visionLabel')}</strong> {t('aboutPage.cards.vision.visionText')}<br />
              <strong>{t('aboutPage.cards.vision.missionLabel')}</strong> {t('aboutPage.cards.vision.missionText')}
            </p>
          </div>

          <div className='homepage-comp5-card'>
            <div className="flex gap-4 items-center mb-4">
              <div className='about-icon'>
                <FaUsers />
              </div>
              <h2 className='homepage-title3 mb-0'>{t('aboutPage.cards.partnerships.title')}</h2>
            </div>
            <p className='homepage-text2 m-0'>
              {t('aboutPage.cards.partnerships.desc')}
            </p>
          </div>

          <div className='homepage-comp5-card'>
            <div className="flex gap-4 items-center mb-4">
              <div className='about-icon'>
                <LuLayoutDashboard />
              </div>
              <h2 className='homepage-title3 mb-0'>{t('aboutPage.cards.development.title')}</h2>
            </div>
            <p className='homepage-text2 m-0'>
              {t('aboutPage.cards.development.desc')}
            </p>
          </div>
        </div>

      </div>

    </div>
  )
}

export default AboutPage;